import Factory from '../utils/factory'

export default Factory({
  value: null,
  type: 'fixed',
  margin: {
    value: null,
    type: 'fixed',
  },
  vat: 25,
  rounding: '50',
})
